import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { UPLOAD_PREFIX } from '../../config/appConfig';
import { useNavigate } from 'react-router-dom';

const DoctorCard = ({ doctor }) => {
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();
  
  const handleCardClick = () => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } });
  };
  
  const renderProfileImage = () => {
    if (doctor.profile_picture && !imageError) {
      return (
        <img 
          src={`${UPLOAD_PREFIX}/storage/${doctor.profile_picture}`}
          alt={doctor.name}
          className="w-full h-[367px] object-cover object-top"
          onError={() => setImageError(true)}
        />
      );
    }
    
    return (
      <div className="w-full h-[367px] bg-purple-100 flex items-center justify-center">
        <span className="text-4xl text-purple-600">{doctor.name.charAt(0)}</span>
      </div>
    );
  };
  
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer" onClick={handleCardClick} >
      {renderProfileImage()}
      
      <div className="p-4 space-y-3">
        <h3 className="text-xl font-semibold">{doctor.name}</h3>
        
        {doctor.specialization && (
          <p className="text-gray-600 font-medium">{doctor.specialization}</p>
        )}

      {/* Debug info */}
      {(
        <div className="mt-2 bg-gray-100 p-3 rounded-md overflow-auto max-h-60 text-xs">
          TEST
          <br />
          {doctor.register_data 
            ? new Date(doctor.register_data).toLocaleDateString('it-IT', {
                month: 'long',
                year: 'numeric'
              })
            : "Campo register_data non presente"}
          <br />
          <br />
          Disponibilità: {doctor.time_preferences 
            ? Object.entries(doctor.time_preferences)
                .filter(([_, value]) => value === true)
                .map(([key, _]) => {
                  switch(key) {
                    case 'morning': return 'Mattina';
                    case 'afternoon': return 'Pomeriggio';
                    case 'evening': return 'Sera';
                    case 'flexible': return 'Flessibile';
                    default: return key;
                  }
                })
                .join(', ') || 'Nessuna preferenza impostata'
            : "Preferenze orarie non disponibili"}
        </div>
      )}

       
        {!doctor.login_enabled && (
          <div className="mt-2 text-sm text-orange-600 bg-orange-50 p-2 rounded">
            Account non attivo
          </div>
        )}
      </div>
    </div>
  );
};

DoctorCard.propTypes = {
  doctor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phone: PropTypes.string,
    register_data: PropTypes.string,
    office_address: PropTypes.string,
    profile_picture: PropTypes.string,
    specialization: PropTypes.string,
    default_price_hour: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tags: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })),
    login_enabled: PropTypes.number,
    time_preferences: PropTypes.shape({
      morning: PropTypes.bool,
      afternoon: PropTypes.bool,
      evening: PropTypes.bool,
      flexible: PropTypes.bool
    })
  }).isRequired
};

export default DoctorCard;